import { render, staticRenderFns } from "./DrawBox.vue?vue&type=template&id=33b41037&scoped=true"
import script from "./DrawBox.vue?vue&type=script&lang=js"
export * from "./DrawBox.vue?vue&type=script&lang=js"
import style0 from "./DrawBox.vue?vue&type=style&index=0&id=33b41037&prod&scoped=true&lang=css"
import style1 from "./DrawBox.vue?vue&type=style&index=1&id=33b41037&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b41037",
  null
  
)

export default component.exports